import settings from '@/constants/constants';
import { consignmentsContract } from '@montugroup/contracts-warehousing-api';
import { createTsRestClient } from '@montugroup/frontend-common';
import { z } from 'zod';

const moddedConsignmentsContract = {
  ...consignmentsContract,
  acknowledgeConsignment: {
    ...consignmentsContract.acknowledgeConsignment,
    responses: {
      ...consignmentsContract.acknowledgeConsignment.responses,
      204: z.void(), // Use z.void() instead of null or the symbol
    },
  },
};

type ClientType = ReturnType<typeof createTsRestClient<typeof moddedConsignmentsContract>>;

let cachedClient: ClientType | null = null;

export const getTsWarehousingConsignmentsClient = (): ClientType => {
  const warehousingClientArgs = {
    baseUrl: settings.warehousingApiUrl,
    baseHeaders: {},
  };

  if (!cachedClient) {
    cachedClient = createTsRestClient(moddedConsignmentsContract, 'warehousingConsignments', warehousingClientArgs);
  }

  return cachedClient;
};
